import * as React from "react";
import tw from 'tailwind-styled-components';
import { Link } from 'gatsby';
import { ArrowRight } from './Arrows';

const buttonType = type => {
  switch (type) {
    case 'tertiary':
      return 'bg-white text-blue-140 hover:drop-shadow-[0_0_62px_rgba(048,076,098,0.2)] hover:bg-blue-100 hover:text-white hover:fill-white focus:outline-2 focus:outline-green-20';
    case 'secondary':
      return 'bg-green-20 text-blue-140 hover:drop-shadow-[0_0_62px_rgba(004,216,095,0.2)] hover:bg-green-100 focus:outline-2 focus:outline-green-40';
    default:
      return 'bg-green-100 text-blue-140 hover:drop-shadow-[0_0_62px_rgba(004,216,095,0.2)] hover:bg-[#04C256] focus:outline-2 focus:outline-green-120';
  }
};

const buttonSize = size => {
  switch (size) {
    case 'small':
      return 'h-11';
    default:
      return 'h-14';
  }
};

export const Button = tw(Link)`
  w-full
  cursor-pointer
  inline-flex
  flex-row
  font-sans
  font-medium
  gap-x-2
  items-center
  justify-center
  leading-normal
  not-italic
  px-4
  rounded-lg
  tracking-normal
  transition-colors
  text-base
  whitespace-nowrap
  md:px-6
  lg:w-max
  ${({ type }) => buttonType(type)};
  ${({ size }) => buttonSize(size)};
`;

export const ArrowIconButton = ({ children, as, ...rest }) => (
  <Button $as={as} {...rest} >
    {children}
    <ArrowRight />
  </Button>
);
